export default __webpack_public_path__ + "media/images/user_photos/27-e0ba7e118fc8f3d08d51947b0896302a.jpg";